import './components/socials.js'
import './components/sliders.js'
import './components/progress.js'
import './components/header.js'
import './components/validate.js'
